import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import CompaniesArea from './companies/CompaniesArea';
import OpportunitiesArea from './opportunities/OpportunitiesArea';
import ContactsArea from './contacts/ContactsArea';

export default function PipelineArea() {
  const { path, url } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/opportunities`}>
        <OpportunitiesArea />
      </Route>

      <Route path={`${path}/companies`}>
        <CompaniesArea />
      </Route>

      <Route path={[`${path}/contacts`]}>
        <ContactsArea />
      </Route>

      <Redirect path="/" to={`${url}/opportunities`} />
    </Switch>
  );
}
